import { useEffect, useState } from "react";

const PhoneInputField = ({
  setValue,
  name,
  label,
  errors,
  defaultValue = "",
  register,
}) => {
  const [formattedValue, setFormattedValue] = useState(defaultValue || "");
  const [unformattedValue, setUnformattedValue] = useState("");

  // Function to format the phone number
  const formatPhoneNumber = (value) => {
    const phoneNumber = value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    const phoneLength = phoneNumber.length;

    if (phoneLength < 4) return phoneNumber;
    if (phoneLength < 7)
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  };

  useEffect(() => {
    if (defaultValue) {
      if (defaultValue.length <= 10) {
        setFormattedValue(formatPhoneNumber(defaultValue)); // Formatted version to display
        setUnformattedValue(defaultValue); // Unformatted version for DB
        setValue(name, defaultValue);
      }
    }
  }, [defaultValue]);

  // Handle input change to store both formatted and unformatted values
  const handleChange = (e) => {
    const value = e.target.value;
    const rawValue = value.replace(/[^\d]/g, ""); // Unformatted value without special characters
    if (rawValue.length <= 10) {
      setFormattedValue(formatPhoneNumber(value)); // Formatted version to display
      setUnformattedValue(rawValue); // Unformatted version for DB
      setValue(name, rawValue); // Pass unformatted value to react-hook-form
    }
  };

  useEffect(() => {
    if (defaultValue.length <= 10) {
      setFormattedValue(formatPhoneNumber(defaultValue));
    }
  }, [defaultValue]);

  return (
    <div className="input-container">
      <label htmlFor={name} className="block font-medium text-text-1/90">
        {label}
      </label>
      <input
        id={name}
        className="w-full px-3  border-b-2 text-base rounded-none bg-content border-bkg2 focus:outline-none focus:border-b-primary text-text-1/75"
        type="tel"
        value={formattedValue}
        onLoad={handleChange}
        onChange={handleChange}
        placeholder="(123) 456-7890"
      />
      {/* {errors && <p className="input-error-text">{errors.message}</p>} */}
      {
        <p className="text-red-400 text-xs text-wrap w-fit">
          {errors && errors.message} <span className="invisible">Sample</span>
        </p>
      }
    </div>
  );
};

export default PhoneInputField;
